import { WorksheetClassificationRuleMap } from "../services/worksheetClassification";

export const workbookWorksheetClassificationRules: Record<string, WorksheetClassificationRuleMap> = {
    "ReviewToolingTest": {
        "M25_RENTAL_PROPERTY": {
            name: "M25_RENTAL_PROPERTY",
            description: "M25 Rental Property",
            inputs: {
                "WorkpaperIdLabel": "C1",
                "WorkpaperId": "D1",
                "WorkpaperVersion": "Q3"
            },
            looseCriteria: (worksheet) => worksheet.name.includes("M25") && worksheet.namedItems.find(item => item.name === "M25_GrossRent")?.type === "Range",
            tightCriteria: (_worksheet, _workbook, inputs) => {
                const hasLabel = inputs["WorkpaperIdLabel"] == "Workpaper ID:";
                const hasId = inputs["WorkpaperId"] === "1922FFE3-2961-4958-95FA-554FE186E83A";

                const isExpectedVersion = inputs["WorkpaperVersion"] === "5.25.0";
                if (!isExpectedVersion) {
                    console.warn(`Unexpected version: ${inputs["WorkpaperVersion"]}`);
                }

                return hasLabel && hasId;
            }
        }
    }
};